/**
 * @author renjie.fei
 * @desc 表单验证 新版
 */

/**
 * 找到父节点中样式为className的节点
 * @param {Element} node
 * @param {String} className
 */
export function findNode (node, className) {
  if (node.className.includes(className)) {
    return node
  }
  return findNode(node.parentNode, className)
}

/**
 * 添加样式
 * @param {Element} node
 * @param {String} className
 */
export function addClass (node, className) {
  let classArr = node.className.split(' ')
  const index = classArr.indexOf(className)

  if (index === -1) {
    classArr.push(className)
    node.className = classArr.join(' ')
  }
}

/**
 * 移除样式
 * @param {Element} node
 * @param {String} className 
 */
export function removeClass (node, className) {
  let classArr = node.className.split(' ')
  const index = classArr.indexOf(className)
  if (index !== -1) {
    classArr.splice(index, 1)
    node.className = classArr.join(' ')
  }
}